module.exports = __webpack_public_path__ + "teqbahn-assets/media/13.b954b6dd.jpg";